export default __webpack_public_path__ + "static/media/66a0b957fb88d044466c330c95a67c15.jpg";